module.exports = __webpack_public_path__ + "img/cod_dg_k.c157819e.png";